<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="500">
      <!-- ✅ New activator slot binding -->
      <template v-slot:activator="{ on, attrs }">
        <v-badge left overlap v-bind="attrs" v-on="on">
          <template v-slot:badge>
            <span v-if="tasks.length > 0">{{ tasks.length }}</span>
          </template>
          <v-btn text small class="ma-0">
            {{ $t("buttons.tasks") }}
          </v-btn>
        </v-badge>
      </template>

      <v-card>
        <v-card-title primary-title>
          {{ $t("pageHeader.pendingTasks") }}
        </v-card-title>

        <v-card-text>
          <v-list two-line v-if="tasks.length > 0">
            <template v-for="(item, index) in tasks" >
              <v-divider v-if="item.divider" :inset="item.inset" />
              <v-list-item :key="index" v-else avatar @click="openTask(item, index)">
                <v-list-item-content>
                  <v-list-item-title v-html="item.title" />
                  <v-list-item-subtitle v-html="item.message" />
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
          <div v-else>Task list is empty.</div>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" text @click="dialog = false">close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <task-view :task="selectedTask" @done="closeTask" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import TaskView from "./TaskView";

export default {
  name: "tasks-button",
  components: {
    TaskView,
  },
  data() {
    return {
      dialog: false,
      selectedTask: null,
    };
  },
  computed: {
    ...mapGetters("tasks", ["tasks"]),
  },
  methods: {
    ...mapActions("tasks", ["initTasks"]),
    openTask(val) {
      this.selectedTask = val;
    },
    closeTask() {
      this.selectedTask = false;
      this.initTasks();
    },
  },
  watch: {
    dialog() {
      this.initTasks();
    },
  },
};
</script>
